"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const numeral_1 = __importDefault(require("numeral"));
const luxon_1 = require("luxon");
const classnames_1 = __importDefault(require("classnames"));
const immutable_1 = require("immutable");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_use_1 = require("react-use");
const Link_1 = __importDefault(require("@mui/material/Link"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const CallSplit_1 = __importDefault(require("@mui/icons-material/CallSplit"));
const AddCircle_1 = __importDefault(require("@mui/icons-material/AddCircle"));
const DeleteOutline_1 = __importDefault(require("@mui/icons-material/DeleteOutline"));
const AccountBalance_1 = __importDefault(require("@mui/icons-material/AccountBalance"));
const core_1 = require("companion-app-components/utils/core");
const categories_1 = require("companion-app-components/flux/categories");
const transactions_1 = require("companion-app-components/flux/transactions");
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const DetailsPanel_1 = __importDefault(require("components/DetailsPanel"));
const index_1 = __importDefault(require("components/QuickenControls/TagsField/index"));
const index_2 = __importDefault(require("components/QuickenControls/AmountField/index"));
const index_3 = __importDefault(require("components/QuickenControls/CategoryField/index"));
const retrievers_1 = require("data/accounts/retrievers");
const utils_1 = require("data/transactions/utils");
const utils_2 = require("utils/utils");
const styles_1 = require("./styles");
const utils_3 = require("./utils");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const log = (0, core_1.getLogger)('component/SplitsAndDetailsPanel/index.tsx');
const SplitsAndDetailsPanel = ({ txn, closeFn, saveFn, deleteFn, getSaveFn, longCats, showCurrencySymbol, onSizeChange, showDetails, hideFooter, unMatchAction, goToTransferAction, forceAutoSave, editable = true, splitSwitch, showSplits, onChangeTxnState, }) => {
    const { classes, theme } = useStyles();
    const { getTxnCurrency } = (0, useQCurrency_1.default)();
    const [txForm, setTxForm] = (0, react_1.useState)(txn.toJS());
    const [initialTxn, setInitialTxn] = (0, react_1.useState)(txn);
    const [isNewTxn, setIsNewTxn] = (0, react_1.useState)(!(0, utils_1.isExistingTxn)(txn));
    const [baseAmount, setBaseAmount] = (0, react_1.useState)((0, utils_3.getBaseAmount)(txn));
    const [currency, setCurrency] = (0, react_1.useState)(getTxnCurrency(txn));
    const [txnDirty, setTxnDirty] = (0, react_1.useState)(false);
    const [rowsCalcModeOff, setRowsCalcModeOff] = (0, react_1.useState)((0, immutable_1.Set)([]));
    const [detailsForm, setDetailsForm] = (0, react_1.useState)(null);
    const [showSource, setShowSource] = (0, react_1.useState)(false);
    const [showSplitsState, setShowSplitsState] = (0, react_1.useState)(showSplits || (transactions_1.transactionsUtils.isSplitTxn(txn) && showDetails));
    const [wasSplit, setWasSplit] = (0, react_1.useState)(transactions_1.transactionsUtils.isSplitTxn(txn));
    const [autoFocusCategory, setAutoFocusCategory] = (0, react_1.useState)(true);
    const [isUpdating, setIsUpdating] = (0, react_1.useState)(null);
    const [sizesChanged, setSizesChanged] = (0, react_1.useState)(true);
    const categoriesById = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getCategoriesById(state));
    const prevTxn = (0, react_use_1.usePrevious)(txn);
    const startingAmountValue = (0, react_1.useRef)(null);
    const txFormRef = (0, react_1.useRef)(txForm);
    const detailsFormRef = (0, react_1.useRef)(detailsForm);
    const txnDirtyRef = (0, react_1.useRef)(txnDirty);
    // @ts-expect-error: Argument of type 'number' is not assignable to parameter of type 'string'.
    const manualZero = (0, react_1.useRef)(parseFloat(txn.amount) === 0);
    (0, react_1.useEffect)(() => {
        detailsFormRef.current = detailsForm;
    }, [detailsForm]);
    (0, react_1.useEffect)(() => {
        txnDirtyRef.current = txnDirty;
    }, [txnDirty]);
    (0, react_1.useEffect)(() => {
        txFormRef.current = txForm;
    }, [txForm]);
    (0, react_1.useEffect)(() => {
        if (txn !== txFormRef.current) {
            setTxForm(txn.toJS());
            setTxnDirty(true);
            if (showDetails) {
                setShowSplitsState((transactions_1.transactionsUtils.isSplitTxn(txn)));
            }
        }
    }, [txn, showDetails]);
    (0, react_1.useEffect)(() => {
        if (sizesChanged) {
            setSizesChanged(false);
            if (onSizeChange) {
                setTimeout(() => onSizeChange(), 50);
            }
        }
    }, [sizesChanged, onSizeChange]);
    const addSplitRow = (0, react_1.useCallback)((txObj, coa = null, tags = null) => {
        if (!txObj.split || !txObj.split.items) {
            txObj.split = {
                items: [],
            };
        }
        let itemAmount = 0;
        if (!manualZero.current) {
            itemAmount = baseAmount - (Number((0, utils_3.sumSplitsRows)(txObj.split.items)));
        }
        else {
            txObj.amount = (0, utils_3.sumSplitsRows)(txObj.split.items); // eslint-disable-line
        }
        const newRow = {
            memo: '',
            tags,
            coa: coa || { type: 'UNCATEGORIZED', id: '0' },
            amount: (0, numeral_1.default)(itemAmount).format('0.00'),
        };
        txObj.split.items.push(newRow);
    }, [baseAmount]);
    // Use the first row as the uncategorized row while calculator mode is on for that row
    const splitUncategorizedRow = (0, react_1.useCallback)((txFormPassed, ignoreFirstRow = false) => 
    // @ts-expect-error: Argument of type '0' is not assignable to parameter of type 'never'.
    (isUpdating || ignoreFirstRow || rowsCalcModeOff.includes(0)) ?
        txFormPassed.split.items.findIndex((item) => ((item.coa && item.coa.type === 'UNCATEGORIZED') && Number(item.coa.id) === 0)) : 0, [isUpdating, rowsCalcModeOff]);
    const initSplits = (0, react_1.useCallback)((addUncategorizedRow = true) => {
        var _a, _b, _c;
        let isUpdatingSplit = null;
        const hasSplits = transactions_1.transactionsUtils.isSplitTxn(txn);
        const updatedTxForm = (0, utils_2.copyObject)(txForm);
        if (hasSplits) {
            isUpdatingSplit = true;
        }
        else {
            updatedTxForm.split = { items: [] };
            // if this is a new split,and there is a root category, make it the first row
            if (updatedTxForm.coa && (updatedTxForm.coa.type !== 'UNCATEGORIZED' && Number(updatedTxForm.coa.id) !== 0)) {
                addSplitRow(updatedTxForm, updatedTxForm.coa, updatedTxForm.tags);
            }
        }
        // if there is not an uncategorized row already, add one
        const splitItems = (_a = updatedTxForm.split) === null || _a === void 0 ? void 0 : _a.items;
        if (splitItems &&
            splitItems.length <= 1 &&
            addUncategorizedRow &&
            (!hasSplits || splitUncategorizedRow(updatedTxForm) < 0)) {
            const txObj = updatedTxForm;
            addSplitRow(txObj, null, null);
            // if we didn't end up with at least 2 split rows, add one more
            if (((_c = (_b = txObj.split) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length) <= 1) {
                // Was causing new txn to have 2 Uncategorized line items
                addSplitRow(txObj, null, null);
            }
        }
        // finally, convert all amounts in split items to strings
        /* eslint-disable no-param-reassign */
        splitItems === null || splitItems === void 0 ? void 0 : splitItems.forEach((splitItem) => {
            splitItem.amount = (0, numeral_1.default)(splitItem.amount).format('0.00');
        });
        if (onChangeTxnState != null) {
            setTimeout(() => {
                setTxForm(Object.assign({}, updatedTxForm));
                txFormRef.current = updatedTxForm;
            }, 100);
        }
        else {
            setTxForm(Object.assign({}, updatedTxForm));
            txFormRef.current = updatedTxForm;
        }
        return isUpdatingSplit;
    }, [txn, txForm, addSplitRow, splitUncategorizedRow, onChangeTxnState]);
    const doAutoSaveRegister = () => forceAutoSave;
    const rebalanceRows = (txObj, index = -1) => {
        if (txObj.split && txObj.split.items && txObj.split.items.length > 0) {
            const unCategorizedRow = splitUncategorizedRow(txObj, index === 0);
            let newSizesChanged = index < 0;
            if (manualZero.current) {
                const amt = Number((0, utils_3.sumSplitsRows)(txObj.split.items));
                txObj.amount = (0, utils_2.normalizeAmt)(amt);
                if (unCategorizedRow < 0) {
                    addSplitRow(txObj);
                    newSizesChanged = true;
                }
            }
            else {
                //
                // complicated rules here... if there is a remainder, we must allocate it
                // if there is an uncategorizedRow, and it is not the row we are on, then use it
                // otherwise create a new row
                //
                const remainder = (0, utils_3.splitRowsRemainder)(txObj);
                if (remainder !== 0) {
                    if (!wasSplit && index !== 0) {
                        const item = txObj.split.items[0];
                        item.amount = (0, numeral_1.default)((0, utils_2.normalizeAmt)(String(Number(item.amount) + remainder))).format('0.00');
                    }
                    else if (unCategorizedRow >= 0) {
                        if (unCategorizedRow !== index) {
                            const item = txObj.split.items[unCategorizedRow];
                            item.amount =
                                (0, numeral_1.default)((0, utils_2.normalizeAmt)(String(Number(item.amount) + remainder))).format('0.00');
                        }
                        else {
                            const item = txObj.split.items[unCategorizedRow];
                            item.amount =
                                (0, numeral_1.default)((0, utils_2.normalizeAmt)(String(Number(item.amount) + remainder))).format('0.00');
                        }
                        if (index === 0) {
                            setWasSplit(true);
                        }
                    }
                    else {
                        addSplitRow(txObj);
                        newSizesChanged = true;
                    }
                }
                if (splitUncategorizedRow(txObj, true) < 0) {
                    newSizesChanged = true;
                }
            }
            setTxForm(Object.assign({}, txObj));
            txFormRef.current = txObj;
            setSizesChanged(newSizesChanged);
        }
    };
    const cleanUpRows = (0, react_1.useCallback)(() => {
        var _a, _b, _c, _d;
        const validRows = (0, utils_3.countNonZeroRows)(txFormRef.current);
        const updatedTxForm = Object.assign({}, txForm);
        if (validRows === 1) {
            updatedTxForm.coa = (_c = (_b = (_a = updatedTxForm.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.coa;
            // @ts-expect-error: 'updatedTxForm.split' is possibly 'null' or 'undefined'.
            (_d = updatedTxForm.split) === null || _d === void 0 ? void 0 : _d.items = [];
        }
        else if (validRows !== 0) {
            updatedTxForm.coa = null;
        }
        else {
            updatedTxForm.split = { items: [] };
        }
        setTxForm(Object.assign({}, updatedTxForm));
        txFormRef.current = updatedTxForm;
        return updatedTxForm;
    }, [txForm, setTxForm]);
    const saveFnMethod = (autoSave = true, close = true) => {
        var _a, _b, _c;
        // fire off a saveCategory action
        let txFormUpdated = txFormRef.current;
        const isSplit = transactions_1.transactionsUtils.isSplitTxn(txFormUpdated);
        log.log('SAVING SPLITs 1', isSplit, (0, utils_2.copyObject)(txFormUpdated));
        if (isSplit) {
            if (manualZero.current) {
                // ensure the transaction amount is equal to the sum of the split rows
                txFormUpdated.amount = (0, utils_3.sumSplitsRows)((_a = txFormUpdated.split) === null || _a === void 0 ? void 0 : _a.items);
            }
            else {
                txFormUpdated.amount = baseAmount;
            }
            txFormUpdated.coa = null;
            rebalanceRows(txFormUpdated);
            // if there is only 1 split item, don't use it.
            if (autoSave || close || (0, utils_3.countNonZeroRows)(txFormUpdated) > 1) {
                txFormUpdated.coa = cleanUpRows().coa;
            }
            // remove any bogus tags
            (_c = (_b = txFormUpdated === null || txFormUpdated === void 0 ? void 0 : txFormUpdated.split) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.forEach((splitItem) => {
                if (splitItem.tags) {
                    splitItem.tags = splitItem.tags.filter((tag) => tag.id !== '0');
                }
            });
        }
        // Merge in details if provided
        if (showDetails && detailsFormRef.current) {
            const { memo, check, tags, attachments, isBill } = detailsFormRef.current;
            const txObj = Object.assign(Object.assign({}, txFormUpdated), { memo,
                check,
                tags,
                attachments,
                isBill });
            setTxForm((prev) => (Object.assign(Object.assign({}, prev), { memo,
                check,
                tags,
                attachments,
                isBill })));
            txFormUpdated = txObj;
        }
        saveFn(txFormUpdated, autoSave, txnDirtyRef.current, !showSplitsState); // autosave
        if (close) {
            closeFn();
        }
        return true;
    };
    (0, react_use_1.useMount)(() => {
        setIsUpdating(showSplitsState ? initSplits() : null);
        (0, utils_3.setInitialFocus)(true, log, showSplitsState);
        if (getSaveFn != null) {
            // @ts-expect-error: Argument of type '(autoSave?: boolean, close?: boolean) => boolean' is not assignable to parameter of type 'boolean'.
            getSaveFn(saveFnMethod);
        }
    });
    const closeAndExit = () => {
        if (!doAutoSaveRegister()) {
            saveFn(initialTxn.toJS(), false, true);
        }
        closeFn();
    };
    //------------------------------------------------------
    // handleKeyDown
    //
    //
    // Items that are relevant
    //
    // details-first-tab
    // details-last-tab
    // [name="row-0-field-category"]  (first tabbable field in split rows)
    // [name="row-${row}-field-amount"] (amount field for any row to skip the drop down button from category
    // splitLastTab (the last tabbable field in the split rows)
    // first-button
    // last-button
    //
    // And of course the feature flag splitsSideBySide determines the orientation of the splits and the details,
    // which impacts the tab order
    //
    const handleKeyDown = (e) => {
        var _a, _b;
        // Hotkey source
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            if (doAutoSaveRegister()) {
                setTimeout(() => saveFnMethod(true, true));
            }
            else {
                closeAndExit();
            }
        }
        if (e.key === 'Enter') {
            // Save
            if (!doAutoSaveRegister()) {
                saveFnMethod();
            }
            e.stopPropagation();
        }
        if (e.key === 'Tab') {
            e.stopPropagation();
            // won't successfully pass the name of the TAGS field.  back/forward tab from Tags is default behavior
            const focusField = (0, utils_3.getNextField)({
                splitsSideBySide: true,
                splitShowNotes: true,
                showDetails,
                showSplitsState,
            }, e.target.name, e.shiftKey ? 'backward' : 'forward');
            if (focusField) {
                e.preventDefault();
                let fld = document.querySelectorAll(`[name="${focusField}"]`)[0];
                // This is a hack until we refactor the tags field.  Select will not pass down the 'name' property
                // to the input field (despite it being in inputProps), and thus, we cannot attach the name directly
                // to the input. So... we attach it to the wrapper, and have to 'dig in' to get the input
                if (focusField.indexOf('tags') > 0) {
                    fld = ((_a = fld.querySelector('button')) === null || _a === void 0 ? void 0 : _a.focus) && ((_b = fld.querySelector('button')) === null || _b === void 0 ? void 0 : _b.focus());
                }
                if (fld) {
                    // @ts-expect-error: Property 'focus' does not exist on type 'Element'.
                    fld.focus();
                }
            }
        }
    };
    const detailsChanged = (details, forceSave) => {
        setDetailsForm(details);
        setTxnDirty(true);
        if (doAutoSaveRegister() || forceSave) {
            setTimeout(() => saveFnMethod(doAutoSaveRegister() ? false : forceSave, false), 500);
        }
    };
    const clearSplits = (updatedTxn) => {
        var _a, _b, _c, _d, _e, _f;
        const newTxn = updatedTxn !== null && updatedTxn !== void 0 ? updatedTxn : txForm;
        if (transactions_1.transactionsUtils.isSplitTxn(newTxn)) {
            newTxn.coa = (0, utils_2.copyObject)(((_c = (_b = (_a = newTxn.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.coa) || initialTxn.coa);
            newTxn.tags = (0, utils_2.copyObject)(((_f = (_e = (_d = newTxn.split) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.tags) || null);
            newTxn.split = null;
            setShowSplitsState(false);
            setTxnDirty(true);
            setTxForm(newTxn);
            txFormRef.current = newTxn;
            saveFnMethod(false, !showDetails);
        }
        if (onSizeChange) {
            onSizeChange();
        }
    };
    (0, react_1.useEffect)(() => {
        if (prevTxn) {
            if (prevTxn.id !== txn.id) {
                setTxForm(txn.toJS());
                setInitialTxn(txn);
                setIsNewTxn(!(0, utils_1.isExistingTxn)(txn));
                setBaseAmount((0, utils_3.getBaseAmount)(txn));
                setCurrency(getTxnCurrency(txn));
                setTxnDirty(false);
                setRowsCalcModeOff((0, immutable_1.Set)([]));
                setDetailsForm(null);
                setShowSource(false);
                setShowSplitsState(showSplits);
                setIsUpdating(showSplitsState ? initSplits() : null);
            }
            if ((prevTxn.split !== txn.split) && txn.split === null) {
                clearSplits(txn.toJS());
            }
        }
        // eslint-disable-next-line
    }, [txn, getTxnCurrency, initSplits, prevTxn, showSplits, showSplitsState]);
    const showSplitsToggle = () => {
        const newState = !showSplitsState;
        if (!newState) {
            clearSplits();
            setShowSplitsState(false);
            // clearSplits
        }
        else {
            // initSplits
            initSplits(true);
            setShowSplitsState(true);
            splitSwitch(newState);
            saveFn(txFormRef.current, false, true);
        }
    };
    const renderSplitHeader = () => {
        const catHead = 'Split this transaction'; // isSplitTxn(txForm) ? 'Split' : 'Splits';
        const splitToggleClass = showDetails ? classes.pointer : null;
        return (<Paper_1.default elevation={0} className={classes.headerRow}>
        {/* -- CATEGORY FIELD -- */}
        <Paper_1.default elevation={0} className={(0, classnames_1.default)(classes.pointer, classes.splitTitleIcon)}>
          <CallSplit_1.default />
        </Paper_1.default>
        <div className={(0, classnames_1.default)('flex2', classes.splitField, splitToggleClass)}>
          <Typography_1.default className={classes.splitTitle}>
            {catHead}
          </Typography_1.default>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            {showSplitsState &&
                <>
                <Typography_1.default mr="10">
                  Transaction Total:
                </Typography_1.default>
                <Typography_1.default mr="30">
                  {`${(0, numeral_1.default)(baseAmount).format('0,00.00')}`}
                </Typography_1.default>
              </>}

            <Switch_1.default id={`split-toggle-${showSplitsState ? 'active' : 'inactive'}`} onClick={() => showSplitsToggle()} checked={showSplitsState} focusRipple inputProps={{
                name: 'splits-panel-onoff',
            }}/>
          </div>

        </div>

      </Paper_1.default>);
    };
    const doAutoSave = () => {
        if (doAutoSaveRegister()) {
            saveFnMethod(false, false);
        }
    };
    //-------------------------------------------------------
    // handleChange
    //
    // This is where we update state of current edit field based on changes
    // global now with specific checks, TODO: make this more configuration driven, not if statements
    //
    const handleChange = (event, index, field) => {
        const txObj = (0, utils_2.copyObject)(txForm);
        switch (field) {
            case 'category':
                if (!event)
                    return;
                txObj.split.items[index].coa = event;
                setTxForm(Object.assign({}, txObj));
                setTxnDirty(true);
                txFormRef.current = txObj;
                doAutoSave();
                break;
            case 'amount':
                txObj.split.items[index][field] = event.target.value;
                break;
            default:
                txObj.split.items[index][field] = event.target.value;
                onChangeTxnState === null || onChangeTxnState === void 0 ? void 0 : onChangeTxnState(txObj);
                break;
        }
        setTxForm(Object.assign({}, txObj));
        setTxnDirty(true);
        txFormRef.current = txObj;
    };
    const toggleCategoryFocus = (focusPassed = true) => {
        setAutoFocusCategory(focusPassed);
    };
    /*
      * RENDER CATEGORY FIELD
      */
    const renderCatField = (opts) => {
        var _a;
        const catFieldName = (opts.index === 0 && !showDetails) ? 'row-0-field-category' : null;
        return (
        // eslint-disable-next-line
        <div key={`split-cat-${opts.index}`} className={(0, classnames_1.default)('flex2', classes.textField)} onKeyDown={handleKeyDown}>
        <index_3.default InputProps={{ input: classes.ellipsePlaceholder }} name={`row-${opts.index}-field-category`} id={`row-${opts.index}-field-category`} onChange={(coa) => handleChange(coa, opts.index, 'category')} value={opts.item.coa} 
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        fontSize={(_a = theme.mixins) === null || _a === void 0 ? void 0 : _a.register.fontSize.default} editable={editable} createEnabled recommendedCategoryType={opts.item.amount > 0 ? categories_1.categoriesTypes.CategoryTypeEnum.INCOME : categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE} disableUnderline onBlur={() => toggleCategoryFocus(false)} initialFocus={autoFocusCategory && catFieldName !== null} longCats={longCats !== null && longCats !== void 0 ? longCats : false} onKeyDown={handleKeyDown} txn={txn}/>
      </div>);
    };
    const tagsChange = (tags, index) => {
        const txObj = (0, utils_2.copyObject)(txForm);
        txObj.split.items[index].tags = tags;
        setTxnDirty(true);
        setTxForm(txObj);
        setTimeout(doAutoSave, 1500);
    };
    /*
      * RENDER TAGS FIELD
    */
    const renderTagsField = (opts) => {
        const immutableTags = (0, immutable_1.List)(opts.item.tags || []);
        return (<div key={`split-tags-${opts.index}`} className={(0, classnames_1.default)('flex2', classes.textField)}>
        <index_1.default onKeyDown={handleKeyDown} value={immutableTags} onChange={(tags) => tagsChange(tags, opts.index)} disableUnderline name={`row-${opts.index}-field-tags`} id={`row-${opts.index}-field-tags`} fieldId={`row-${opts.index}`} editable={editable}>
        </index_1.default>
      </div>);
    };
    /*
      * RENDER NOTES FIELD
    */
    const renderNotesField = (opts) => (<div key={`split-notes-${opts.index}`} className={(0, classnames_1.default)(classes.textField)}>
      <TextField_1.default id={`row-${opts.index}-field-notes`} name={`row-${opts.index}-field-notes`} className={classes.inputStyle} onChange={(e) => handleChange(e, opts.index, 'memo')} onKeyDown={handleKeyDown} placeholder="Memo" value={opts.item.memo || ''} InputProps={{ disableUnderline: true }}/>
    </div>);
    const handleAmountFocus = (event, index) => {
        var _a, _b;
        startingAmountValue.current = Number((_b = (_a = txForm.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[index].amount);
    };
    const handleAmountBlur = (event, index) => {
        var _a, _b;
        const txObj = txForm;
        if ((_b = (_a = txObj.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[index]) {
            txObj.split.items[index].amount = event.target.value;
            rebalanceRows(txObj, index);
            if (Number(txObj.split.items[index].amount) !== startingAmountValue.current) {
                // @ts-expect-error: Argument of type 'any' is not assignable to parameter of type 'never'
                setRowsCalcModeOff(rowsCalcModeOff.add(index));
                doAutoSave();
            }
        }
    };
    /*
      * RENDER AMOUNT FIELD
    */
    const renderAmountField = (opts) => {
        const catObj = opts.item.coa && categoriesById.get(opts.item.coa.id);
        const isIncomeCategory = catObj && catObj.type === 'INCOME';
        return (<div key={`split-amount-${opts.index}`} className={(0, classnames_1.default)('amountField', 'flex2', classes.textField)}>
        <index_2.default className={classes.inputStyle} name={`row-${opts.index}-field-amount`} id={`row-${opts.index}-field-amount`} onChange={(e) => handleChange(e, opts.index, 'amount')} onBlur={(e) => handleAmountBlur(e, opts.index)} onFocus={(e) => handleAmountFocus(e, opts.index)} onKeyDown={handleKeyDown} proposedSign={isIncomeCategory ? 1 : -1} 
        // @ts-expect-error: Type 'string' is not assignable to type 'number'.
        value={String(opts.item.amount) || ''} editable disableUnderline amountType="amount" currencySymbol={showCurrencySymbol ? currency : 'N/A'}/>
      </div>);
    };
    const renderOneSplitRow = (item, index, total) => {
        const lastRow = (index === (total - 1));
        const fields = [];
        fields.push(renderCatField({ item, index }));
        fields.push(renderTagsField({ item, index }));
        fields.push(renderNotesField({
            item,
            index,
        }));
        fields.push(renderAmountField({ item, index }));
        const removeSplitRow = (row) => {
            const txObj = (0, utils_2.copyObject)(txForm);
            txObj.split.items[row] = { memo: '', tags: null, coa: { type: 'UNCATEGORIZED', id: '0' }, amount: '0.00' };
            txObj.split.items.splice(row, 1);
            rebalanceRows(txObj);
            setTxnDirty(true);
            setTimeout(doAutoSave, 10);
        };
        const addOneSplitRow = () => {
            const txObj = (0, utils_2.copyObject)(txForm);
            addSplitRow(txObj);
            setTxForm(txObj);
            if (onSizeChange) {
                onSizeChange();
            }
        };
        return (<Paper_1.default key={`spl-${index}`} elevation={0} className={classes.listRow}>
        {fields}
        {/* -- ADD ROW -- */}
        <Paper_1.default elevation={0} className={(0, classnames_1.default)(classes.pointer, classes.rowIcons)}>
          <QIconButton_1.default aria-label="Remove Split Row" onClick={() => removeSplitRow(index)} name={`row-${index}-remove-row`} id={`row-${index}-remove-row`} size="small">
            <DeleteOutline_1.default>
            </DeleteOutline_1.default>
          </QIconButton_1.default>
          {lastRow &&
                <QIconButton_1.default className={classes.addIconButton} aria-label="Add Split Row" onClick={() => addOneSplitRow()} size="medium-no-padding" name={lastRow ? 'splits-last-tab' : null} id={`add-split-row-${index}`}>
              <AddCircle_1.default />
            </QIconButton_1.default>}
        </Paper_1.default>
      </Paper_1.default>);
    };
    const renderSplitRows = () => {
        var _a, _b;
        const splitRows = [];
        // render the existing rows
        if (txForm.split) {
            (_b = (_a = txForm.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.forEach((item, index) => {
                var _a, _b;
                // @ts-expect-error: Property 'length' does not exist
                splitRows.push(renderOneSplitRow(item, index, (_b = (_a = txForm.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length));
            });
        }
        return splitRows;
    };
    /*
      * RENDER 'APPEARS ON...'
      * TEXT FIELD
    */
    const renderAppearsOn = () => {
        const { cpData } = txForm;
        let bankName;
        if (cpData) {
            bankName = (0, retrievers_1.getAccountString)(txForm.accountId);
        }
        const matchVerb = 'match';
        return (txForm.cpData &&
            <div className={classes.detailsRow}>
        <div className={classes.rowIcon}>
          <AccountBalance_1.default />
        </div>
        <div className={classes.bankInfoContainer}>
          <Typography_1.default variant="caption" color="textSecondary" display="block">
            {`Appears on your ${bankName} statement as `}
            <Link_1.default onClick={() => (0, utils_3.clickPayeeLink)(cpData === null || cpData === void 0 ? void 0 : cpData.payee)}>
              {cpData === null || cpData === void 0 ? void 0 : cpData.payee}
            </Link_1.default>
            {` on ${luxon_1.DateTime.fromFormat((cpData === null || cpData === void 0 ? void 0 : cpData.postedOn) || '', 'yyyy-M-d').toLocaleString(luxon_1.DateTime.DATE_MED)} `}
            {showSource && `source is ${txForm.source}`}
          </Typography_1.default>

          {(0, utils_1.getMatchState)(txForm) === 'matched' &&
                    <Typography_1.default variant="caption" color="textSecondary" display="block">
              This transaction was matched to an existing transaction when it was downloaded.&nbsp;
              {unMatchAction && transactions_1.transactionsUtils.canTxnBeUmatched(txn) &&
                            <Link_1.default onClick={unMatchAction}>
                {`Un${matchVerb}`}
              </Link_1.default>}
            </Typography_1.default>}
        </div>
      </div>);
    };
    const renderSplitPanel = () => {
        const containerClass = showDetails ? 'sidebyside' : null;
        return (<div className={(0, classnames_1.default)(classes.panelContainer, !editable ? 'disable' : '')}>
        <Paper_1.default className={(0, classnames_1.default)(classes.panel)} onKeyDown={handleKeyDown} elevation={0}>
          <div className={classes.splitsDetailsParent}>
            {showDetails &&
                <Paper_1.default elevation={0} className={(0, classnames_1.default)(classes.webFirstDetails, containerClass)}>
                <DetailsPanel_1.default onChange={detailsChanged} txForm={txn} onSizeChange={onSizeChange} unMatchAction={unMatchAction} firstTabName="details-first-tab" lastTabName="details-last-tab" goToTransferAction={goToTransferAction} editable={editable}/>
              </Paper_1.default>}
            <div className={showDetails ? classes.rightCol : classes.splitsOnly}>
              <Paper_1.default elevation={0} className={(0, classnames_1.default)(classes.splitsContainer, containerClass)}>
                {renderSplitHeader()}
                {showSplitsState && renderSplitRows()}
                {/* Section below is the 'appears on your statement as...' section
              * This function is a bit of misnomer because the splits panel also renders the details panel
              * so in this sense it's more like a parent flex container
            */}
              </Paper_1.default>
              {showDetails &&
                <>
                  {renderAppearsOn()}
                </>}

            </div>
          </div>
          {!hideFooter &&
                <div className={classes.buttonHolder}>
              {showDetails && !isNewTxn &&
                        <Paper_1.default elevation={0} className={classes.buttonsLeft}>
                  <Button_1.default className={classes.deleteButton} onClick={deleteFn} color="primary" name="first-button" id="splits-panel-delete">
                    Delete Transaction
                  </Button_1.default>
                </Paper_1.default>}
              <Paper_1.default elevation={0} className={classes.buttonsRight}>
                {!doAutoSaveRegister() &&
                        <Button_1.default className={classes.buttons} onClick={closeAndExit} color="primary" id="splits-panel-cancel">
                    Cancel
                  </Button_1.default>}
                <Button_1.default className={classes.buttons} onClick={(doAutoSaveRegister() ? closeAndExit : saveFnMethod)} name="last-button" color="primary" id="splits-panel-save">
                  {doAutoSaveRegister() ? 'Close' : 'Save'}
                </Button_1.default>
              </Paper_1.default>
            </div>}
        </Paper_1.default>
      </div>);
    };
    return renderSplitPanel();
};
SplitsAndDetailsPanel.whyDidYouRender = true;
exports.default = SplitsAndDetailsPanel;
